import { all, takeLatest } from "redux-saga/effects";
import {
  TRACKING_LIST,
  TRACKING_STATS,
  TRACKING_ABANDONED,
  TRACKING_MARKETING,
  TRACKING_JOURNEY,
  TRACKING_YMM,
  TRACKING_EXPORT,
  TRACKING_CHECKOUT,
  TRACKING_LEADS_EXPORT,
  TRACKING_CUSTOMIZE,
} from "../actions/tracking.actions.types";
import httpClient from "../services/http.client";
import axiosInstance from "../../utilities/axios.instance";
import * as Effects from "redux-saga/effects";

const call = Effects.call;
const select = Effects.select;

const EVENT_TYPE_URL_MAP = {
  "abandoned-cart": "tracking/abandoned?export=true",
  product_view: "tracking/marketing?export=true",
  checkout: "tracking/checkout?export=true",
  customize: "tracking/customize?export=true",
};

function* getTrackingList({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "tracking/list",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false, data: null });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* getTrackingStats({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "tracking/stats",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false, data: null });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* getTrackingAbandoned({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "tracking/abandoned",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false, data: null });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* getTrackingMarketing({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "tracking/marketing",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false, data: null });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* getTrackingJourney({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "tracking/journey",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false, data: null });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* getTrackingYmm({ payload: { callback } }) {
  const payload = {
    method: "get",
    url: "tracking/ymm",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false, data: null });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* getTrackingCheckout({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "tracking/checkout",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false, data: null });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* getTrackingCustomize({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "tracking/customize",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false, data: null });
  } else {
    if (callback) callback({ success: true, data: result.data });
  }
}

function* getTrackingLeadsExport({ payload: { data, callback } }) {
  const token = yield select(({ user: { token } }) => token);

  if (!token?.accessToken) {
    if (callback) callback({ success: false });
    return;
  }

  try {
    const url = EVENT_TYPE_URL_MAP[data?.eventType] || "tracking/export";

    const response = yield call(axiosInstance, {
      method: "get",
      url,
      params: data,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token.accessToken}`,
      },
    });

    if (callback)
      callback({
        success: true,
        blob: response.data,
        format: data?.format || "csv",
      });
  } catch (error) {
    if (callback) callback({ success: false });
  }
}

function* getTrackingExport({ payload: { data, callback } }) {
  const token = yield select(({ user: { token } }) => token);

  if (!token?.accessToken) {
    if (callback) callback({ success: false });
    return;
  }

  try {
    const response = yield call(axiosInstance, {
      method: "get",
      url: "tracking/export",
      params: data,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token.accessToken}`,
      },
    });

    if (callback)
      callback({
        success: true,
        blob: response.data,
        format: data?.format || "csv",
      });
  } catch (error) {
    if (callback) callback({ success: false });
  }
}

function* Tracking() {
  yield all([
    takeLatest(TRACKING_LIST, getTrackingList),
    takeLatest(TRACKING_STATS, getTrackingStats),
    takeLatest(TRACKING_ABANDONED, getTrackingAbandoned),
    takeLatest(TRACKING_MARKETING, getTrackingMarketing),
    takeLatest(TRACKING_JOURNEY, getTrackingJourney),
    takeLatest(TRACKING_YMM, getTrackingYmm),
    takeLatest(TRACKING_EXPORT, getTrackingExport),
    takeLatest(TRACKING_CHECKOUT, getTrackingCheckout),
    takeLatest(TRACKING_LEADS_EXPORT, getTrackingLeadsExport),
    takeLatest(TRACKING_CUSTOMIZE, getTrackingCustomize),
  ]);
}

export default Tracking;
